import * as React from 'react';
import styled from 'styled-components';
import FieldError from './FieldError';

const FieldWrapper = (props: Props) => {
	const { fieldName, label, children, labelClassName, reverseLabelOrder, icon } = props;
	return (
		<section data-fieldname={fieldName}>
			{reverseLabelOrder && children}
			<Label className={labelClassName} htmlFor={fieldName}>
				<LabelText>{label}</LabelText>
				{icon}
			</Label>
			{!reverseLabelOrder && children}
			<FieldError fieldName={fieldName} />
		</section>
	);
};

interface Props {
	fieldName: string;
	label: string | JSX.Element;
	children?: React.ReactNode;
	labelClassName?: string;
	reverseLabelOrder?: boolean;
	icon?: JSX.Element;
}

FieldWrapper.defaultProps = {
	children: undefined,
	labelClassName: undefined,
	reverseLabelOrder: false,
	icon: undefined
};

const Label = styled.label`
	display: block;
	margin-bottom: 4px;
`;

const LabelText = styled.span`
	font-weight: bold;
	color: #262526;
	opacity: 0.65;
`;

export default FieldWrapper;
